import Utils from '../../services/Utils'
import { FormErrorStrategy } from '../config/ErrorHandler'
import { GApi, defineCancelApiObject, defaultHeaders } from '../config/GApi'

const BillingResourceApi = {
  getList: async function (cancel = false) {
    const response = await GApi.request({
      url: '/core/billing-resource',
      method: 'GET',
      headers: defaultHeaders(),
      signal: cancel
        ? cancelApiObject[this.getList.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
  getDiscovered: async function (cancel = false) {
    const response = await GApi.request({
      url: '/core/billing-resource/discovered',
      method: 'GET',
      headers: defaultHeaders(),
      signal: cancel
        ? cancelApiObject[this.getDiscovered.name].handleRequestCancellation()
            .signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
  upsert: async function (post, cancel = false) {
    const response = await GApi.request({
      url: '/core/billing-resource',
      method: 'PUT',
      headers: defaultHeaders(),
      data: post,
      errorStrategy: FormErrorStrategy,
      signal: cancel
        ? cancelApiObject[this.upsert.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
  delete: async function (id, cancel = false) {
    const response = await GApi.request({
      url: '/core/billing-resource/' + id,
      method: 'DELETE',
      headers: defaultHeaders(),
      signal: cancel
        ? cancelApiObject[this.delete.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
}

const cancelApiObject = defineCancelApiObject(BillingResourceApi)

export default BillingResourceApi
